import { AppStoreState } from './app-store';
import { ConfigStoreState } from './config-store';
import { ViewStateStoreState } from './view-state-store';

export interface State {
   app?: AppStoreState.State;
   config?: ConfigStoreState.State;
   viewState?: ViewStateStoreState.State;
}